import { useEffect, useRef, useState } from "react";

export default function StatCounter({ end, suffix = "", prefix = "", duration = 1800, label }) {
    const [value, setValue] = useState(0);
    const ref = useRef(null);
    const started = useRef(false);

    useEffect(() => {
        const el = ref.current;
        if (!el) return;
        const io = new IntersectionObserver(
            ([entry]) => {
                if (entry.isIntersecting && !started.current) {
                    started.current = true;
                    const start = performance.now();
                    const from = 0;
                    const to = end;
                    const tick = (t) => {
                        const p = Math.min(1, (t - start) / duration);
                        const eased = 1 - Math.pow(1 - p, 3);
                        setValue(Math.round(from + (to - from) * eased));
                        if (p < 1) requestAnimationFrame(tick);
                    };
                    requestAnimationFrame(tick);
                }
            },
            { threshold: 0.4 }
        );
        io.observe(el);
        return () => io.disconnect();
    }, [end, duration]);

    return (
        <div ref={ref} className="text-center">
            <div className="font-display text-5xl sm:text-6xl font-extrabold tracking-tight text-white">
                {prefix}
                {value.toLocaleString()}
                {suffix}
            </div>
            <div className="mt-3 text-sm uppercase tracking-[0.2em] text-white/60">{label}</div>
        </div>
    );
}
